import { isAnnotationIdLocked } from '../utils/annotationLockUtils';
import {
  getTextBackgroundCardTextId,
  isTextBackgroundCardGroup,
  TEMPLATE_CARD_BACKGROUND_KEY,
} from '../utils/annotationGroupUtils';
import { findCardBackgroundPartnerId } from '../utils/textTemplateCardLayout';
import { TOOLS_IDS } from '../utils/constants';

export const REMOVE_ANNOTATIONS = 'REMOVE_ANNOTATIONS';

const expandRemovalIdsForTextStickerGroups = (annotations, ids = []) => {
  const expanded = new Set(ids);

  ids.forEach((id) => {
    const annotation = annotations?.[id];
    if (!annotation) {
      return;
    }

    if (annotation.name === TOOLS_IDS.TEXT) {
      const cardId = findCardBackgroundPartnerId(annotations, id);
      if (cardId) {
        expanded.add(cardId);
      }
      return;
    }

    if (annotation[TEMPLATE_CARD_BACKGROUND_KEY] && annotation.groupId) {
      const textId = isTextBackgroundCardGroup(
        annotations,
        annotation.groupId,
      )
        ? getTextBackgroundCardTextId(annotations, annotation.groupId)
        : null;
      if (textId) {
        expanded.add(textId);
      }
    }
  });

  return [...expanded];
};

const removeAnnotations = (state, payload) => {
  // Work on a shallow copy so we don't mutate state.annotations in place. The
  // undo/redo middleware snapshots the *previous* state right after this reducer
  // runs, so mutating the original object would corrupt the undo snapshot and make
  // "undo delete" unable to restore the removed annotation.
  const annotations = { ...state.annotations };
  let newSelectionsIds = state.selectionsIds;
  let removedAny = false;
  const idsToRemove = expandRemovalIdsForTextStickerGroups(
    state.annotations,
    payload.annotationsIds,
  );

  idsToRemove.forEach((id) => {
    if (isAnnotationIdLocked(state.annotations, id)) {
      return;
    }

    if (!annotations[id]) {
      return;
    }

    removedAny = true;
    newSelectionsIds = newSelectionsIds.filter(
      (selectionId) => selectionId !== id,
    );

    if (state.designLayer) {
      const annotationNode = state.designLayer.findOne(`#${id}`);
      if (annotationNode) {
        annotationNode.destroy();
      }
    }
    delete annotations[id];
  });

  if (!removedAny) {
    return state;
  }

  return {
    ...state,
    // not stored in state, used in reducer to consider in undo/redo stacks
    isDesignState: payload.isDesignState || true,
    annotations,
    selectionsIds: newSelectionsIds,
  };
};

export default removeAnnotations;
